module.exports = __webpack_public_path__ + "r-v3/img/stroke-width_off.c691ec15.svg";